import { TimeInMs } from '../../../types';

const intervals = [
  {
    label: 'year',
    timespan: TimeInMs.year
  },
  {
    label: 'month',
    timespan: TimeInMs.month
  },
  {
    label: 'week',
    timespan: TimeInMs.week
  },
  {
    label: 'day',
    oneOffLabel: 'yesterday',
    timespan: TimeInMs.day
  },
  {
    label: 'hour',
    timespan: TimeInMs.hour
  },
  {
    label: 'minute',
    timespan: TimeInMs.minute
  }
].sort((intervalA, intervalB) => {
  // Descending order based on timespan.
  return intervalB.timespan - intervalA.timespan;
});

export function formatTimeSince(input: Date | number): string {
  const date = typeof input === 'number' ? new Date(input) : input;
  const timeSinceNow = new Date().getTime() - date.getTime();

  const interval = intervals.find((interval) => {
    return interval.timespan <= timeSinceNow;
  });

  if (interval == null) {
    return 'just now';
  }

  const numberOfIntervals = Math.floor(timeSinceNow / interval.timespan);
  return (numberOfIntervals < 2) ? (
    interval.oneOffLabel ?? `a ${interval.label} ago`
  ) : `${numberOfIntervals} ${interval.label}s ago`;
}
